import { GzPurchaseCardLayoutWebComponent } from './component/GzPurchaseCardLayoutWebComponent';

export { GzPurchaseCardLayoutWebComponent };
